var _circle, _path, _path2, _path3, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 7.5,
    fill: "#E20613"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 3.90625C7.76175 3.90625 3.90625 7.76175 3.90625 12.5C3.90625 17.2382 7.76175 21.0938 12.5 21.0938C17.2382 21.0938 21.0938 17.2382 21.0938 12.5C21.0938 7.76175 17.2382 3.90625 12.5 3.90625ZM12.5 19.5312C8.623 19.5312 5.46875 16.377 5.46875 12.5C5.46875 8.623 8.623 5.46875 12.5 5.46875C16.377 5.46875 19.5312 8.623 19.5312 12.5C19.5312 16.377 16.377 19.5312 12.5 19.5312Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 11.037C12.0683 11.037 11.7188 11.3866 11.7188 11.8182V15.7245C11.7188 16.1561 12.0683 16.5057 12.5 16.5057C12.9317 16.5057 13.2812 16.1561 13.2812 15.7245V11.8182C13.2812 11.3866 12.9317 11.037 12.5 11.037V11.037Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 8.49426C12.0683 8.49426 11.7188 8.84386 11.7188 9.27551V9.50989C11.7188 9.94154 12.0683 10.2911 12.5 10.2911C12.9317 10.2911 13.2812 9.94154 13.2812 9.50989V9.27551C13.2812 8.84484 12.9317 8.49426 12.5 8.49426Z",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 8,
    stroke: "#E20613",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoHover);
export default __webpack_public_path__ + "static/media/InfoHover.a059f63a15a76c386424f8fe393d2a08.svg";
export { ForwardRef as ReactComponent };